<!--在职继承--->
<template>
    <div class="page flex-col">
        <div class="section_1 flex-col" v-if="showIndex">
            <img class="image_1" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/shopper.png" alt="" />
            <span class="text_4">在职继承</span>
            <div class="text-wrapper_2">
                <span class="text_5">当成员或顾客/顾客群有变更时，企业可将在职成员的顾客和顾客群分配给其他成员继续提供服务。</span>
                <span class="text_6" @click="toAllocationRecord()">分配详情</span>
            </div>
            <span class="text_7">需要转接的</span>
            <div class="section_5 flex-col" @click="showChoicePopup()">
                <div v-if="selectedCustomerIds.length > 0" class="box_3 flex-row justify-between">
                    <span v-if="selectedEmp.name" class="text_8">{{ selectedEmp.name }}等</span>
                    <span style="margin-left:0px;" class="text_8">{{ selectedCustomerIds.length }}位客户</span>
                    <!-- <span class="text_8">{{selectedCustomerIds.length}}的{{selectedCustomerIds.length}}位客户</span> -->
                </div>
                <div v-else class="box_3 flex-row justify-between">
                    <img class="label_4" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/addCustomers.png" alt="" />
                    <span class="text_8">选择顾客/顾客群</span>
                </div>
            </div>
            <span class="text_9">转接给</span>
            <div class="section_6 flex-col" @click="showeEmployeesPopup(1)">
                <div v-if="beReplacedEmp && beReplacedEmp.name" class="section_7 flex-row justify-between">
                    <img class="avatar" referrerpolicy="no-referrer" :src="beReplacedEmp.avatar" alt="" />
                    <span class="empName">{{ beReplacedEmp.name }}</span>
                </div>
                <div v-else class="section_7 flex-row justify-between">
                    <img class="label_5" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/addCustomers.png" alt="" />
                    <span class="text_10">选择接替的成员</span>
                </div>
            </div>
            <button class="text-wrapper_3" v-if="selectedCustomerIds.length && beReplacedEmp.name" @click="toSave()">确定</button>
        </div>

        <!-- 选择顾客、顾客群事件弹窗 -->
        <van-popup v-model="showChoice" round position="bottom" get-container="#app" closeable>
            <div class="popup-container">
                <div class="list-box">
                    <div class="box_2 flex-col">
                        <div class="block_3 flex-col">
                            <div class="group_8 flex-col" @click="showeEmployeesPopup(2)">
                                <img class="image_2" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/member.png" alt="" />
                                <span class="text_12">按成员选择</span>
                                <span class="text_13">选择有工作变更的成员的顾客/顾客群</span>
                            </div>
                        </div>
                        <div class="block_4 flex-col">
                            <div class="group_9 flex-col" @click="showeCustomerPopup()">
                                <img class=" image_3" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/searchMembers.png" alt="" />
                                <span class="text_14">指定顾客/顾客群</span>
                                <span class="text_15">直接选择有变更的顾客/顾客群</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>

    import request from "@/utils/request";
    import { mapState } from 'vuex';

    import { Popup, Cell, Field, Tag, Search, CellGroup, Dialog, Toast } from "vant";


    export default {
        components: {
            [CellGroup.name]: CellGroup,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Tag.name]: Tag,
        },
        name: "appointmentInherit",
        data() {
            return {
                showChoice: false, //选择顾客弹窗
                // checkedEmployeesList: {
                //     contactCount: 0,
                // },   //选择接替的成员
                checkedCustomersList: {
                    contactCount: 0,
                },     //选择的顾客
                searchStr: "",
                loading: false,
                finished: false,
                refreshing: false,
                // storeInfoList: [],
                showIndex: true,
            };
        },
        computed: {
            ...mapState({
                transferCustomerList: (state) => state.inherit.transferCustomerList,
                selectedCustomerIds: (state, getters) => getters.selectedCustomerIds,
                selectedEmp: (state) => state.inherit.selectedEmp,
                beReplacedEmp: (state) => state.inherit.beReplacedEmp,
            })
        },

        mounted() {
        },

        methods: {

            // 选择顾客弹窗
            showChoicePopup() {
                this.showChoice = true;
            },

            //选择员工
            showeEmployeesPopup(type) {
                //跳转员工选择页
                this.$router.push({ name: "onJobEmployeesList", query: { toType: type } });
            },

            //选择顾客
            showeCustomerPopup() {
                //跳转顾客选择页
                this.$router.push({ name: "specifiedHome", query: {} });
            },

            //分配详情
            toAllocationRecord() {
                //跳转顾客选择页
                this.$router.push({ name: "inheritRecord", query: {} });
            },

            //保存在职继承
            toSave() {
                var message = "";
                if (this.selectedEmp.name) {
                    message = `确认将${JSON.stringify(this.selectedEmp.name)}的客户分配给${this.beReplacedEmp.name}？`;
                }
                else {
                    message = `确认分配客户给${this.beReplacedEmp.name}？`;
                }
                Dialog.confirm({
                    title: '分配客户',
                    message: message,
                })
                    .then(() => {
                        var param = {
                            empConlist: this.transferCustomerList,
                            groupList: [],
                            newEmployeeId: this.beReplacedEmp.employeeId,
                            newEmpwxUserId: this.beReplacedEmp.wxUserId
                        }
                        request({
                            url: `/transferCust/transferTraCust`,
                            method: "post",
                            data: param,
                        })
                            .then((res) => {
                                this.$store.commit('inherit/SET_ALL_TRANSFER_CUSTOMER', [])
                                this.$store.commit('inherit/SET_SELECTED_EMPId', {})
                                this.$store.commit('inherit/SET_BEREPLACED_EMPId', {})
                                //跳转成功页面
                                this.$router.push({ name: "inheritSuccess", query: {} });
                            }).catch((error) => {
                                Toast({ position: 'top', message: error ?? '' })
                            });
                    })
            },
        },
    };
</script>

<style scoped>
    .page {
        position: relative;
        width: 750px;
        height: 1630px;
        background-color: rgba(245, 246, 247, 1);
        overflow: hidden;
    }

    .section_1 {
        width: 750px;
        height: 1230px;
    }

    .section_2 {
        height: 176px;
        background-color: rgba(67, 117, 201, 1);
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        width: 750px;
    }

    .image_1 {
        width: 50px;
        height: 51px;
        margin: 80px 0 0 30px;
    }

    .text_4 {
        width: 200px;
        height: 70px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 50px;
        white-space: nowrap;
        line-height: 70px;
        text-align: left;
        margin: 30px 0 0 30px;
    }

    .text-wrapper_2 {
        width: 690px;
        height: 80px;
        overflow-wrap: break-word;
        text-align: justify;
        font-size: 0;
        margin: 30px 0 0 30px;
    }

    .text_5 {
        font-size: 28px;
        color: rgba(160, 172, 181, 1);
        line-height: 40px;
    }

    .text_6 {
        font-size: 28px;
        color: rgba(77, 114, 193, 1);
        line-height: 40px;
    }

    .text_7 {
        width: 130px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin: 80px 0 0 30px;
    }

    .section_5 {
        height: 100px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 1);
        width: 690px;
        margin: 30px 0 0 30px;
    }

    .box_3 {
        width: 270px;
        height: 40px;
        margin: 30px 0 0 20px;
    }

    .label_4 {
        width: 40px;
        height: 40px;
    }

    .text_8 {
        /* width: 210px; */
        height: 40px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin-left: 20px;
    }

    .text_9 {
        width: 78px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin: 40px 0 0 30px;
    }

    .section_6 {
        height: 100px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 1);
        width: 690px;
        margin: 30px 0 0 30px;
    }

    .section_7 {
        width: 256px;
        height: 40px;
        margin: 30px 0 0 20px;
    }

    .label_5 {
        width: 40px;
        height: 40px;
        border-radius: 12px;
    }

    .avatar {
        width: 60px;
        height: 60px;
        border-radius: 12px;
        margin-top: -6px;
    }

    .text_10 {
        width: 196px;
        height: 40px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin-left: 20px;
    }

    .empName {
        width: 196px;
        height: 40px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin: 5px 0 0 10px;
    }

    .text-wrapper_3 {
        height: 88px;
        border-radius: 44px;
        background-color: rgba(51, 63, 72, 1);
        width: 630px;
        margin: 171px 0 0 60px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
    }

    .text_11 {
        width: 66px;
        height: 45px;
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        font-size: 32px;
        letter-spacing: 1px;
        white-space: nowrap;
        line-height: 45px;
        text-align: center;
        margin: 22px 0 0 283px;
    }

    .box_2 {
        width: 690px;
        height: 852px;
        margin: 50px 0 0 30px;
    }

    .label_6 {
        width: 32px;
        height: 32px;
        margin-left: 658px;
    }

    .block_3 {
        height: 320px;
        border-radius: 8px;
        background-color: rgba(255, 255, 255, 1);
        margin-top: 30px;
        width: 690px;
    }

    .group_8 {
        width: 462px;
        height: 200px;
        margin: 60px 0 0 114px;
    }

    .image_2 {
        width: 80px;
        height: 80px;
        margin-left: 191px;
    }

    .text_12 {
        width: 170px;
        height: 48px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        white-space: nowrap;
        line-height: 48px;
        text-align: left;
        margin: 22px 0 0 146px;
    }

    .text_13 {
        width: 462px;
        height: 40px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin-top: 10px;
    }

    .block_4 {
        height: 320px;
        border-radius: 8px;
        background-color: rgba(255, 255, 255, 1);
        margin-top: 20px;
        width: 690px;
    }

    .group_9 {
        width: 378px;
        height: 200px;
        margin: 60px 0 0 156px;
    }

    .image_3 {
        width: 80px;
        height: 80px;
        margin-left: 149px;
    }

    .text_14 {
        width: 255px;
        height: 48px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        white-space: nowrap;
        line-height: 48px;
        text-align: left;
        margin: 22px 0 0 62px;
    }

    .text_15 {
        width: 378px;
        height: 40px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: left;
        margin-top: 10px;
    }
</style>